export class AudioStreamAnalyzer {
  #audioContext
  #audioSource
  #streamDataArray
  #streamAnalyser
  #definition
  #streamBufferLength

  constructor(audioContext, audioSource, definition = 32) {
    this.#audioContext = audioContext;
    this.#audioSource = audioSource;
    this.#definition = definition;

    this.#streamAnalyser = this.#audioContext.createAnalyser();
    this.#audioSource.connect(this.#streamAnalyser);

    this.#streamAnalyser.fftSize = this.#definition; // use 2048 for big definition
    this.#streamBufferLength = this.#streamAnalyser.frequencyBinCount;
    this.#streamDataArray = new Uint8Array(this.#streamBufferLength);
  }

  getData() {
    this.#streamAnalyser.getByteTimeDomainData(this.#streamDataArray);
    return this.#streamDataArray;
  }

  // Loudness from 0 to 100 (RMS of the waveform), for the mic meter
  getLevel() {
    const data = this.getData();
    let sum = 0;

    for (const value of data) {
      const sample = (value - 128) / 128;
      sum += sample * sample;
    }

    const rms = Math.sqrt(sum / data.length);
    return Math.min(100, Math.round(rms * 400));
  }
}
